import { OrderStatusType } from 'api/types/entity/order/orderStatusType';

export type OrderAvailableStatusesMap = Record<
  OrderStatusType,
  {
    isRequiredReason: boolean;
    isRequiredFmNumber: boolean;
    isRequiredClosedDate: boolean;
  }
>;

export enum OrderFormTab {
  orderDetails = 'orderDetails',
  executionHistory = 'executionHistory',
}
